import styled from '@emotion/styled'

export const Cont = styled.div({
  display: 'flex',
  flexDirection: 'column',
})

export const BottomActionsContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%', 
  margin: '10px 0px',
})